export default function Resume () {
    return (
        <h2 className="resume"> Resume </h2>
    )
}